import React from 'react';

import { IconArrowUpRight } from '@tabler/icons-react';

type LinkMoreProps = {
  className?: string;
  textClassName?: string;
  target?: React.HTMLAttributeAnchorTarget;
  text: 'Learn' | 'Read';
  link: string;
  onClick?: () => void;
};

const LinkMore = (props: LinkMoreProps) => {
  const className = props.className
    ? `${classNames.link} ${props.className}`
    : classNames.link;

  const textClassName = props.textClassName
    ? props.textClassName
    : classNames.text;

  return (
    <a
      className={className}
      href={props.link}
      target={props.target}
      rel="noreferrer"
      onClick={props.onClick}
    >
      <p className={textClassName}>{props.text} more</p>
      <IconArrowUpRight className={textClassName} />
    </a>
  );
};

const classNames = {
  link: ['tw-flex', 'tw-gap-[8px]', 'md:tw-gap-[16px]', 'tw-items-center'].join(
    ' ',
  ),
  text: ['tw-link2', 'tw-text-periwinkle-700'].join(' '),
};

export { LinkMore };
